import { render, staticRenderFns } from "./AdminMailingsTable.vue?vue&type=template&id=5f3e565e&scoped=true"
import script from "./AdminMailingsTable.vue?vue&type=script&lang=js"
export * from "./AdminMailingsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3e565e",
  null
  
)

export default component.exports